export default {
    name: "PlatformPrintApplyFirstAuditManage",
	mounted: function () {
		this.init();
	},
    data() {
        return {
            searchForm: {
                recName: null,
				sendName: null,
                firstAuditResult: null,
                time: null,
                pageIndex: 1,
                pageSize: 50
            },
            tableData: [],
            selected: [],
            total: 0
        }
    },
    methods: {
		init(){
            let conditionParam = this.$routerUtil.getParam();
            if(conditionParam && conditionParam.searchForm){
                conditionParam = conditionParam.searchForm;
            }
			console.log(conditionParam);
			this.$routerUtil.clearParam();
			if(conditionParam){
                this.$nextTick(() => {
                    this.searchForm = conditionParam;
                    this.doSearch();
                });
			}
		},
        handleSizeChange(val){
            this.searchForm.pageSize = val;
            this.doSearch();
        },
        handleCurrentChange(val){
            this.searchForm.pageIndex = val;
            this.doSearch();
        },
		rowClick(row){
			this.$refs.table.toggleRowSelection(row);
		},
        handleSelectionChange(val) {
            this.selected = val;
        },
        doReset(){
			this.searchForm.recName="";
			this.searchForm.sendName="";
			this.searchForm.firstAuditResult="";
			this.searchForm.time=[];
		},
        doSearch() {
            this.tableData.splice(0, this.tableData.length);
            let param = Object.assign({}, this.searchForm);
            param.sendCompanyName = param.sendName;
            param.receiveCompanyName = param.recName;
            delete param.sendName;
            delete param.recName;
            // param.pageIndex = this.pageIndex;
            // param.pageSize = this.pageSize;
            // 只查询未审核
            // param.printStatus = 0;
            param.firstAuditResult = this.searchForm.firstAuditResult;
            const time = param.time;
            delete param.time;
            if (time) {
                param.applyTimeBeginTime = time[0];
                param.applyTimeEndTime = time[1];
            }
            console.log(this.searchForm.firstAuditResult)
            console.log(param.firstAuditResult)
            param = this.$paramUtil.clearEmpty(param);
            this.$axios.get('/api/prints/printManage', {params: param}).then(response => {
                console.log(response.data);
                if (response.data.status === '1') {
                    this.tableData = response.data.resultData.rows;
                    this.total = response.data.resultData.total;
                }else{
                    this.$message({
                        message: this.$t('common.message.operateFail'),
                        type: 'error',
                        center: true
                    });
                }
            }).catch(e => {
                console.log(e);
                this.$message({
                    message: this.$t('common.message.operateFail'),
                    type: 'error',
                    center: true
                });
            });
        },
		doFirstAudit(){
			const row = this.getSelectedRow();
			if (row) {
				const conditionData = new Object();
				conditionData.searchForm = this.searchForm;
				conditionData.row = row;
				this.$router.push('print-apply-first-audit');
				this.$routerUtil.setParam(conditionData);
			}
		},
        getSelectedRow(){
            if (this.selected.length > 1) {
                this.$message({
                    message: this.$t('common.message.onlyOneRow'),
                    type: 'warning',
                    center: true
                });
                return null
            }
            if (this.selected.length < 1) {
                this.$message({
                    message: this.$t('common.message.atLastOneRow'),
                    type: 'warning',
                    center: true
                });
                return null
            }
            if(this.selected[0].printStatus !== 0){
                this.$message({
                    message: this.$t('common.message.firstAuditState'),
                    type: 'warning',
                    center: true
                });
                return null
            }
            return this.selected[0];
        },
        stateFormat(row) {
            if (row.firstAuditResult === 1) {
                return this.$t('p_printResetAudit.agree');
            } else if (row.firstAuditResult === 0) {
                return this.$t('p_printResetAudit.refuse');
            } else if (row.firstAuditResult == null) {
                return this.$t('p_printResetAudit.nonAudit');
            }
        }
    }
}
